import React from 'react';
import PropTypes from 'prop-types';
import ActiveLabel from "../../ActiveLabel";
import {I18nUtils} from "../../../../../i18n/I18nUtils";
import Arrays from "../../../utils/Arrays";
import nl2br from "../../../utils/nl2br";
import {OverlayTrigger, Popover} from "react-bootstrap";
import Button from "../../Button";

export default class MachinesTabRow extends React.Component {

  static renderHead(id, showOutsource = false, checkOptions = null ) { // checkOptions = { text = '', checked = false, onChecked = (checked) => {} }
    return(
      <tr>
        {
          checkOptions !== null ?
            <th className="check-export-delete">
              <input
                type="checkbox"
                className="filled-in chk-col-blue-grey"
                id={'machine-tab-row-header-' + id}
                checked={checkOptions.checked}
                onChange={({target}) => checkOptions.onChecked(target.checked)}
              />
              <label htmlFor={'machine-tab-row-header-' + id}><strong>{checkOptions.text}</strong></label>
            </th>
            : null
        }
        <th>{I18nUtils.tr('TR_ESTADO')}</th>
        <th>{I18nUtils.tr('TR_ID')}</th>
        <th>{I18nUtils.tr('TR_MARCA')}</th>
        <th>{I18nUtils.tr('TR_MODELO')}</th>
        { showOutsource ? <th>{I18nUtils.tr('TR_SUBCONTRATA')}</th> : null }
        <th>{I18nUtils.tr('TR_ESQUEMA')}</th>
        <th></th>
      </tr>
    );
  }

  constructor(init){
    super(init);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange({target}){
    this.props.actionSelectItem(this.props.machine, target.checked);
  }

  renderName(machine) {
    if (machine.error) {
      const popover = (
        <Popover id="popover-positioned-right" title="">{nl2br(machine.error)}</Popover>
      );
      return (
        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={popover}>
          <span style={{ color: 'red'}}>{machine.name}</span>
        </OverlayTrigger>
      );
    }
    return machine.name;
  }

  render() {
    const { machine } = this.props;
    return (
      <tr>
        {
          this.props.selectedIds !== null ?
            <td className="check-export-delete">
              <input
                type="checkbox"
                id={'check-machine-' + machine.id}
                className="filled-in chk-col-blue-grey"
                onChange={this.handleChange}
                checked={Arrays.contains(this.props.selectedIds, this.props.machine.id)}
              />
              <label htmlFor={'check-machine-' + machine.id}>{this.props.selectText}</label>
            </td>
            : null
        }
        <td><ActiveLabel state={machine.machine_state} /></td>
        <td>{this.renderName(machine)}</td>
        <td><strong>{machine.brand}</strong></td>
        <td><strong>{machine.model}</strong></td>
        {this.props.showOutsource ? <td>{machine.company ? machine.company.name : ''}</td> : null}
        <td>{machine.document_schema ? machine.document_schema.name : ''}</td>
        { this.props.action ?
          <Button text={this.props.actionText} className="btn-primary btn-sm btn-block" onClick={() => this.props.action(machine)} />
          : null }
      </tr>
    );
  }

}


MachinesTabRow.propTypes = {
  machine: PropTypes.objectOf(PropTypes.any).isRequired,

  selectedIds: PropTypes.array,
  actionSelectItem: PropTypes.func,
  selectText: PropTypes.string,
  showOutsource: PropTypes.bool,
  action: PropTypes.any,
  actionText: PropTypes.string,
};

MachinesTabRow.defaultProps = {
  showOutsource: false,
};




// WEBPACK FOOTER //
// ./src/app/shared/components/tabs/machines/MachinesTabRow.js